/**
 * Shown near listing description and/or defects fields so sellers know contact
 * details are prohibited in either box.
 */
export default function DescriptionContactPolicyNotice() {
  return (
    <p className="mt-2 text-xs leading-relaxed text-amber-950 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
      <span className="font-semibold">
        Do not put your phone number, address, negotiation requests, etc., in
        the description and defect boxes.
      </span>{" "}
      Buyers reach you through Sell It Off after your listing is approved.
      Listings that break this rule may be removed without notice.
    </p>
  );
}
